import productsModule from './productsModule'; // TODO: optional default product response filters...

export default function productsExtension() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    id: 'products',
    server: process.browser ? undefined : {
      init: function init() {
        require('./config');
      }
    },
    redux: {
      modules: [productsModule]
    }
  };
}